import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { type z } from "zod";

import { scheduledExportFormSchema } from "@features/data-export-v2/components/scheduled-export-form/scheduled-export-form-schema";
import { zodResolver } from "@hookform/resolvers/zod";

export const DEFAULT_TIME_FRAME = {
  frequency: "DAILY",
  time: "",
} as z.infer<typeof scheduledExportFormSchema>["trigger"]["timeFrames"][number];

export const ScheduleExportFormProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const scheduleExportForm = useForm<z.infer<typeof scheduledExportFormSchema>>(
    {
      resolver: zodResolver(scheduledExportFormSchema),
      defaultValues: {
        reportData: {
          type: "TOUCHPOINTS",
        },
        destination: {
          type: "GCS",
          fileName: "touchpoints-report",
          exportFormat: "CSV",
          bucketName: "",
          isBucketValid: false,
        },
        trigger: {
          type: "SCHEDULED",
          subType: "TIME_BASED",
          scheduleName: "Touchpoints export",
          timeFrames: [DEFAULT_TIME_FRAME],
        },
      } as Partial<z.infer<typeof scheduledExportFormSchema>>,
    },
  );

  return <FormProvider {...scheduleExportForm}>{children}</FormProvider>;
};

export const useScheduleExportFormContext = () => {
  const scheduleExportForm =
    useFormContext<z.infer<typeof scheduledExportFormSchema>>();

  if (!scheduleExportForm) {
    throw new Error(
      "useScheduleExportFormContext must be used within a ScheduleExportFormProvider",
    );
  }

  return scheduleExportForm;
};
